import {
    createCachedSelector,
    DuckSelector,
} from '@atc/modular-redux';

import { resultsDuckCreator } from 'axl-ducks';

import { srpDuckPreset } from '@/ducks/presets/index.js';

const DEFAULT_EMPTY_ARRAY = [];

const srpNewCarBoostDuck = resultsDuckCreator({
    ...srpDuckPreset,
    store: 'boost',
}).extend({
    selectors: () => ({
        getAvailableInventory: new DuckSelector((selectors) => (state) => selectors.getActiveInventory(state) || DEFAULT_EMPTY_ARRAY),
        getIndividualListing: new DuckSelector((selectors) => createCachedSelector(
            selectors.getActiveInventory,
            (state, index) => index,
            (activeInventory = [], index) => activeInventory[index]
        )((state, index) => index || 'default')),
    }),
});

export default srpNewCarBoostDuck;
